import useSWR, { SWRResponse } from 'swr';
import { Room } from '../../../providers/api/dtos/room';
import { getRoomsByPropertyId } from '../../../providers/api/room/roomsProvider';

export const ROOMS_RID = '/property/:id/rooms';

export default function useRooms(propertyId?: number): SWRResponse<Room[], Error> {
  return useSWR(propertyId ? [ROOMS_RID, propertyId] : null, () => getRoomsByPropertyId(propertyId!));
}
